/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Text, MovieClip, Button } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='bottomBar'>
        <Image position={[0, 1828]} name='bg' src='bg_ui_wide_square' />
        <Sprite position={[1136, 1780]} name='winPanel'>
            <Image name='bg' src='win_ui_wide_square' />
            <Text
                position={[286, 72]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 170,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={1000}
                name='fieldText'
                localeTextID=''
                text='$24000.00'
            />
            <Text
                position={[626, 274]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 60,
                    fontStyle: 'normal',
                    fill: '#FFD200',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={313}
                name='label'
                localeTextID=''
                text='WIN'
            />
        </Sprite>
        <Button position={[3469, 146]} hitArea={{ width: 325, x: 14, y: 14, type: 'rectangle', height: 194 }} name='menuButton'>
            <Sprite>
                <Image src='menu_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='menu_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='menu_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='menu_button_disabled' />
            </Sprite>
        </Button>
        <Button position={[18, 146]} hitArea={{ width: 325, x: 14, y: 14, type: 'rectangle', height: 194 }} name='homeButton'>
            <Sprite>
                <Image src='home_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='home_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='home_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='home_button_disabled' />
            </Sprite>
        </Button>
        <Button position={[18, 921]} hitArea={{ width: 335, x: 14, y: 14, type: 'rectangle', height: 200 }} name='betButton'>
            <Sprite>
                <Image src='bet_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='bet_button_normal' />
            </Sprite>
            <Sprite>
                <Image src='bet_button_pressed' />
            </Sprite>
            <Sprite>
                <Image src='bet_button_disabled' />
            </Sprite>
        </Button>
        <Text
            position={[2739, 2075]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 60,
                fontStyle: 'normal',
                fill: '#06BF00',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={1000}
            name='tickerRight'
            localeTextID=''
            text='PRESS SPIN BUTTON'
        />
        <Text
            position={[2739, 2075]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 80,
                fontStyle: 'normal',
                fill: '#FFFFFF',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={1000}
            name='pointsBalance'
            localeTextID=''
            text=''
        />
        <Text
            position={[102, 2075]}
            style={{
                fontFamily: 'PF DinDisplay Pro',
                fontSize: 60,
                fontStyle: 'normal',
                fill: '#D1D1D1',
                align: 'center',
                fontWeight: 'bold'
            }}
            maxWidth={1000}
            name='tickerLeft'
            localeTextID=''
            text='40 LINES BET MULTIPLIER'
        />
        <Sprite position={[23, 1828]} name='totalBetPanel'>
            <Text
                position={[181, 12]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 120,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={800}
                name='fieldText'
                localeTextID=''
                text='$10.000'
            />
            <Text
                position={[179, 137]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 60,
                    fontStyle: 'normal',
                    fill: '#FFD200',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={800}
                name='label'
                localeTextID=''
                text='TOTAL BET'
            />
        </Sprite>
        <Sprite position={[2980, 1828]} name='balancePanel'>
            <Text
                position={[-16, 137]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 61,
                    fontStyle: 'normal',
                    fill: '#FFD200',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={548}
                name='label'
                localeTextID=''
                text='CASH'
            />
            <Text
                position={[-140, 12]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 120,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={800}
                name='fieldText'
                localeTextID=''
                text='$1000.00'
            />
        </Sprite>
        <Button position={[3276, 759]} hitArea={{ x: 258, y: 272, type: 'circle', radius: 259 }} name='spinButton'>
            <Sprite>
                <MovieClip name='bg'>
                    <Image src='spin_button_normal' />
                    <Image src='spin_turbo_button_normal' />
                </MovieClip>
                <Image src='hold_for_settings_normal' />
                <Image src='hold_for_settings_normal_en' />
            </Sprite>
            <Sprite>
                <MovieClip name='bg'>
                    <Image src='spin_button_normal' />
                    <Image src='spin_turbo_button_normal' />
                </MovieClip>
                <Image src='hold_for_settings_normal' />
                <Image src='hold_for_settings_normal_en' />
            </Sprite>
            <Sprite>
                <MovieClip name='bg'>
                    <Image src='spin_button_pressed' />
                    <Image src='spin_turbo_button_pressed' />
                </MovieClip>
                <Image src='hold_for_settings_pressed' />
                <Image src='hold_for_settings_pressed_en' />
            </Sprite>
            <Sprite>
                <MovieClip name='bg'>
                    <Image src='spin_button_disabled' />
                    <Image src='spin_turbo_button_disabled' />
                </MovieClip>
                <Image src='hold_for_settings_disabled' />
                <Image src='hold_for_settings_disabled_en' />
            </Sprite>
        </Button>
        <Button position={[3276, 759]} hitArea={{ x: 258, y: 272, type: 'circle', radius: 259 }} name='spinButtonWithoutHoldSettings'>
            <Sprite>
                <MovieClip name='bg'>
                    <Image src='spin_button_normal' />
                    <Image src='spin_turbo_button_normal' />
                </MovieClip>
                <Image src='hold_for_settings_normal' />
            </Sprite>
            <Sprite>
                <MovieClip name='bg'>
                    <Image src='spin_button_normal' />
                    <Image src='spin_turbo_button_normal' />
                </MovieClip>
                <Image src='hold_for_settings_normal' />
            </Sprite>
            <Sprite>
                <MovieClip name='bg'>
                    <Image src='spin_button_pressed' />
                    <Image src='spin_turbo_button_pressed' />
                </MovieClip>
                <Image src='hold_for_settings_pressed' />
            </Sprite>
            <Sprite>
                <MovieClip name='bg'>
                    <Image src='spin_button_disabled' />
                    <Image src='spin_turbo_button_disabled' />
                </MovieClip>
                <Image src='hold_for_settings_disabled' />
            </Sprite>
        </Button>
        <Button position={[3276, 759]} hitArea={{ x: 258, y: 272, type: 'circle', radius: 259 }} name='stopAutoplayButton'>
            <Sprite>
                <Image src='stop_button_normal' />
                <Image src='stop_autoplay_normal_en' />
                <Text
                    position={[178, 216]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 110, fontWeight: 'bold', fill: '#2A2A2A', align: 'center' }}
                    maxWidth={200}
                    name='spinsAmountField'
                    text='500'
                />
            </Sprite>
            <Sprite>
                <Image src='stop_button_normal' />
                <Image src='stop_autoplay_normal_en' />
                <Text
                    position={[178, 216]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 110, fontWeight: 'bold', fill: '#2A2A2A', align: 'center' }}
                    maxWidth={200}
                    name='spinsAmountField'
                    text='500'
                />
            </Sprite>
            <Sprite>
                <Image src='stop_button_pressed' />
                <Image src='stop_autoplay_pressed_en' />
                <Text
                    position={[178, 221]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 100, fontWeight: 'bold', fill: '#2A2A2A', align: 'center' }}
                    maxWidth={200}
                    name='spinsAmountField'
                    text='500'
                />
            </Sprite>
            <Sprite>
                <Image src='stop_button_disabled' />
                <Image src='stop_autoplay_disabled_en' />
                <Text
                    position={[178, 212]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 110, fontWeight: 'bold', fill: '#2A2A2A', align: 'center' }}
                    maxWidth={200}
                    name='spinsAmountField'
                    text='500'
                />
            </Sprite>
        </Button>
        <Button position={[3276, 759]} hitArea={{ x: 258, y: 272, type: 'circle', radius: 259 }} name='spinsLeftButton'>
            <Sprite>
                <Image src='spin_button_normal' />
                <Image src='spins_left_normal_en' />
                <Text
                    position={[99, 70]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 250, fontWeight: 'bold', fill: '#FFFFFF', align: 'center' }}
                    maxWidth={340}
                    name='txt'
                    text='20'
                />
            </Sprite>
            <Sprite>
                <Image src='spin_button_normal' />
                <Image src='spins_left_normal_en' />
                <Text
                    position={[99, 70]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 250, fontWeight: 'bold', fill: '#FFFFFF', align: 'center' }}
                    maxWidth={340}
                    name='txt'
                    text='20'
                />
            </Sprite>
            <Sprite>
                <Image src='spin_button_pressed' />
                <Image src='spins_left_pressed_en' />
                <Text
                    position={[99, 91]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 220, fontWeight: 'bold', fill: '#FFFFFF', align: 'center' }}
                    maxWidth={340}
                    name='txt'
                    text='20'
                />
            </Sprite>
            <Sprite>
                <Image src='spin_button_disabled' />
                <Image src='spins_left_disabled_en' />
                <Text
                    position={[99, 70]}
                    style={{ fontFamily: 'PF DinDisplay Pro', fontSize: 250, fontWeight: 'bold', fill: '#CACACA', align: 'center' }}
                    maxWidth={340}
                    name='txt'
                    text='20'
                />
            </Sprite>
        </Button>
    </Sprite>
);
